/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const CredentialClaimLinkedFileValue: core.serialization.ObjectSchema<
    serializers.CredentialClaimLinkedFileValue.Raw,
    Truvity.CredentialClaimLinkedFileValue
> = core.serialization.object({
    digestMultibase: core.serialization.property('digest_multibase', core.serialization.string().optional()),
    id: core.serialization.string(),
});

export declare namespace CredentialClaimLinkedFileValue {
    export interface Raw {
        digest_multibase?: string | null;
        id: string;
    }
}
